import { Button, Col, Form, Input, Row } from "antd";
import { strings } from "utils/localizedStrings";
import BaseModal from "components/modals/base/BaseModal";
import ChangePasswordViewModel from "../viewModel/ChangePasswordViewModel";

const ChangePasswordModal = ({
  open,
  onCancel,
}: {
  open: boolean,
  onCancel: () => void,
}) => {
  const [form] = Form.useForm();
  const {
    onSubmit,
    submitLoading
  } = ChangePasswordViewModel(onCancel);
  return (
    <BaseModal
      visible={open}
      onClose={onCancel}
      title={strings.GlobalLabels.ResetPassword}
      width={520}
      showCloseFooter={false}
    >
      <div className="px-4">
        <Form
          onFinish={onSubmit}
          form={form}
          layout="vertical"
          className="w-full"
          requiredMark={false}
          disabled={submitLoading}
        >
          <Row gutter={[32, 0]} justify={"center"}>
            <Col span={24}>
              <Form.Item
                name="oldPassword"
                label={<span className="font-bold">{strings.UserManagement.Columns.OldPass}</span>}
                rules={[{ required: true, message: strings.GlobalMessage.Required }]}
              >
                <Input.Password
                  placeholder={strings.GlobalLabels.Placeholder + strings.UserManagement.Columns.OldPass.toLowerCase()}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="password"
                label={<span className="font-bold">{strings.GlobalLabels.NewPassword}</span>}
                rules={[
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error(strings.GlobalMessage.Required));
                      }
                      if (value && value?.length < 6) {
                        return Promise.reject(new Error(strings.GlobalMessage.PasswordLength));
                      }
                      return Promise.resolve();
                    },
                  })
                ]}
              >
                <Input.Password
                  placeholder={strings.GlobalLabels.Placeholder + strings.GlobalLabels.NewPassword.toLowerCase()}
                  minLength={6}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="confirmPassword"
                label={<span className="font-bold">{strings.GlobalLabels.PasswordConfirmed}</span>}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error(strings.GlobalMessage.Required));
                      }
                      if (value && value?.length < 6) {
                        return Promise.reject(new Error(strings.GlobalMessage.PasswordLength));
                      }
                      if (value && value !== getFieldValue("password")) {
                        return Promise.reject(new Error(strings.GlobalMessage.PasswordNotMatch));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder={strings.GlobalLabels.Placeholder + strings.GlobalLabels.PasswordConfirmed.toLowerCase()}
                  minLength={6}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  type="primary"
                  size="large"
                  className="w-full xl:h-[50px] h-[40px] font-[600]"
                  loading={submitLoading}>
                  {strings.GlobalLabels.Confirmed}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </BaseModal>
  )
}

export default ChangePasswordModal;
